// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.

// frontend/src/components/execution-plans/ApprovalPackageCard.jsx

import React from "react";
import { ExecutionPlanSection, EmptyPanel, bodyTextStyle, displayValue } from "./ExecutionSummaryCard";

export default function ApprovalPackageCard({ approvalPackage }) {
  if (!approvalPackage) {
    return <EmptyPanel title="No approval package" message="Approval package details were not generated for this task yet." />;
  }

  const resources = Array.isArray(approvalPackage.affected_resources) ? approvalPackage.affected_resources : [];
  const steps = Array.isArray(approvalPackage.planned_execution_steps) ? approvalPackage.planned_execution_steps : [];

  return (
    <ExecutionPlanSection eyebrow="Approval" title="Operator approval package" badge={approvalPackage.required ? "approval required" : "review"}>
      <p style={bodyTextStyle}>{displayValue(approvalPackage.change_summary)}</p>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: 12, marginTop: 14 }}>
        <div style={{ border: "1px solid rgba(148, 163, 184, 0.16)", borderRadius: 14, padding: 12, background: "rgba(2, 6, 23, 0.24)" }}>
          <strong style={{ color: "#f8fafc", display: "block", marginBottom: 6 }}>Reason</strong>
          <p style={bodyTextStyle}>{displayValue(approvalPackage.reason)}</p>
        </div>
        <div style={{ border: "1px solid rgba(148, 163, 184, 0.16)", borderRadius: 14, padding: 12, background: "rgba(2, 6, 23, 0.24)" }}>
          <strong style={{ color: "#f8fafc", display: "block", marginBottom: 6 }}>Expected Validation</strong>
          <p style={bodyTextStyle}>{displayValue(approvalPackage.expected_validation)}</p>
        </div>
      </div>
      {resources.length ? <p style={{ ...bodyTextStyle, marginTop: 12 }}>Affected: {resources.map(displayValue).join(", ")}</p> : null}
      {steps.length ? (
        <ol style={{ color: "#bfdbfe", fontSize: 13, lineHeight: 1.55, margin: "14px 0 0", paddingLeft: 18 }}>
          {steps.map((step, index) => <li key={`approval-step-${index}`}>{displayValue(step)}</li>)}
        </ol>
      ) : null}
      <div style={{ marginTop: 14, border: "1px solid rgba(251, 191, 36, 0.22)", borderRadius: 14, padding: 12, background: "rgba(120, 53, 15, 0.16)" }}>
        <strong style={{ color: "#fde68a", display: "block", marginBottom: 4 }}>Guardrail</strong>
        <p style={bodyTextStyle}>{displayValue(approvalPackage.approval_guardrail, "No approval is executed, sent, or applied automatically.")}</p>
      </div>
    </ExecutionPlanSection>
  );
}
